import { type PropertyDefinitions } from '../../types';
import hierarchyDefaultSvg from '../../assets/hierarchyDefault.svg';

// DSL describing the available properties for a hierarchy diagram.
const properties: PropertyDefinitions = {
  variant: {
    name: 'Collection of properties defining a common variant of the diagram',
    type: 'selectProperties',
    options: [
      {
        value: 'default',
        properties: { rankGap: 60, nodeGap: 40 },
        name: 'Default hierarchy diagram',
        icon: hierarchyDefaultSvg,
      },
    ],
  },

  // Note that orientation is not a rotation. Layout is always done top to
  // bottom and left to right.
  orientation: {
    name: 'The overall orientation of the diagram',
    type: 'select',
    options: [
      { value: 'south', name: 'Arrange vertically below the first node' },
      { value: 'north', name: 'Arrange vertically above the first node' },
      { value: 'east', name: 'Arrange horizontally left the first node' },
      { value: 'west', name: 'Arrange horizontally right the first node' },
    ],
  },
  childLayoutDirection: {
    name: 'The direction child nodes should be laid out',
    type: 'select',
    // This property takes an level number so that it can be specified at the diagram level to be different at different levels.
    // e.g. childLayoutDirection1, childLayoutDirection2
    supportsLevels: true,
    options: [
      {
        value: 'normal',
        name: 'Children lay out in the opposite direction to the parent/child relationship',
      },
      {
        value: 'perpendicular',
        name: 'Children lay out in the same direction to the parent/child relationship',
      },
    ],
  },
  childLayoutLocation: {
    name: 'The location of the children relative to the parent',
    type: 'select',
    supportsLevels: true,
    options: [
      { value: 'center', name: 'Parent is centered on the children' },
      { value: 'start', name: 'Parent is adjacent to the first child' },
      { value: 'end', name: 'Parent is adjacent to the last child' },
      {
        value: 'offsetBefore',
        name: 'Children are offset left or above the parent',
      },
      {
        value: 'offsetAfter',
        name: 'Children are offset right or below the parent',
      },
    ],
  },
  childConnector: {
    name: 'Connector or line style between parent and child',
    type: 'select',
    supportsLevels: true,
    options: [
      { value: 'line', name: 'An orthogonal' },
      { value: 'left', name: 'Parent is left aligned' },
      { value: 'right', name: 'Parent is right aligned' },
      {
        value: 'offsetBefore',
        name: 'Children are offset left or above the parent',
      },
      {
        value: 'offsetAfter',
        name: 'Children are offset right or below the parent',
      },
    ],
  },
};

export default properties;
